import cls from "./Final.module.scss";
import moneyIcon from "../../shared/assets/images/money.svg";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../shared/redux/store";
import { resetCount, setPause } from "../../shared/redux/game/slice";
import { getRecord, setRecord } from "../../shared/utils/record";
import { useEffect, useState } from "react";
import router, { ROUTES } from "../../app/router";
import { FormattedMessage } from "react-intl";

const Final = () => {
  const count = useSelector((state: RootState) => state.game.count);
  const [bestCount, setBestCount] = useState<number>(() => getRecord());
  const dispatch = useDispatch();

  useEffect(() => {
    if (count > bestCount) {
      setRecord(count);
      setBestCount(count);
    }
  }, [count, bestCount]);

  return (
    <div className={cls.container}>
      <div className={cls.contentContainer}>
        <div className={cls.counter}>
          <img alt="Money" src={moneyIcon} className={cls.moneyIcon} />
          <div>{count}</div>
        </div>
        {bestCount === count && count > 0 ? (
          <h1>
            <FormattedMessage id="final__new-record-text" />
          </h1>
        ) : (
          <h1>
            <FormattedMessage
              id="final__record-text"
              values={{
                value: bestCount,
              }}
            />
          </h1>
        )}

        <div className={cls.buttonContainer}>
          <button
            onClick={() => {
              dispatch(resetCount());
              dispatch(setPause(false));
              router.navigate(ROUTES.GAME);
            }}
          >
            <FormattedMessage id="final__btn__game_text" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Final;
